import React from "react";
import { useLang } from "@/i18n";

export function shippingName(details, legacy, t) {
  const code = details?.service_code || legacy || "standard";
  if (code === "automatic" || code === "standard" || code === "express" || code === "none") return t(`shipping.${code}`);
  return details?.service_name || code;
}

export function ShippingEstimate({ details }) {
  const { t } = useLang();
  if (!details?.estimated_days && !details?.estimated_delivery_date) return null;
  return <span className="block text-xs font-normal text-muted-foreground">{t("shipping.estimated")} {details.estimated_days ? `${details.estimated_days} ${t("shipping.businessDays")}` : details.estimated_delivery_date}</span>;
}

export default function ShippingDetails({ order }) {
  const { t } = useLang();
  return <div className="mt-2 text-sm text-navy/70" data-testid="order-shipping-method">
    <span>{t("checkout.shippingMethod")}: {shippingName(order.shipping_details, order.shipping_method, t)}</span>
    <ShippingEstimate details={order.shipping_details} />
  </div>;
}
